import { datadogRum } from '@datadog/browser-rum';
import getEnvironment from '@square/environment-utils/environment';
import config from '@banking/savings-onboarding-app/config/environment';

const APPLICATION_ID = '402adf73-7ba6-49e8-ae0b-f3f549d70141';
const CLIENT_TOKEN = 'pub404cdeb0da15884cb5c87d090ba85583';
const SERVICE = 'sfs-frontend';
const SITE = 'datadoghq.com';

// Requires as per
// https://docs.datadoghq.com/real_user_monitoring/browser/?tab=us#initialization-parameters
const DatadogEnvironment = {
  PRODUCTION: 'prod',
  STAGING: 'staging',
};

export function initialize() {
  const environment = getEnvironment();
  if (!environment.isProduction && !environment.isStaging) {
    return;
  }
  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    compressIntakeRequests: true,
    env: environment.isProduction
      ? DatadogEnvironment.PRODUCTION
      : DatadogEnvironment.STAGING,
    service: SERVICE,
    site: SITE,
    trackResources: true,
    // The trackUserInteractions parameter enables the automatic collection of user clicks in your application.
    // Sensitive and private data contained on your pages may be included to identify the elements interacted with.
    trackUserInteractions: false,
    version: config.APP.version?.slice(0, 8),
  });
}

export default {
  initialize,
};
